import { useContext, ref, computed } from "@nuxtjs/composition-api"


const useSalePrice = () => {
  const { app } = useContext()

  const getSalePrices = async (skus) => {
    const customerToken = app.$cookies.get("vsf-customer")
    if(!customerToken) return
    const baseUrl = app.$config.baseUrl + '/get-prices-mbc?customerToken=' + customerToken
    const catchData = await fetch(baseUrl, {
      method: "POST",
      body: JSON.stringify(skus),
      headers: {
        "Content-Type": "application/json",
      }
    })

    const response = await catchData.json()

    return response
  }
  return {
    getSalePrices,
  }
}

export default useSalePrice